import { createAction, props } from '@ngrx/store';
import { GetDocumentParam } from '../../../models/contract-model';
import { DocumentData } from './document.reducers';

export enum DocumentActionTypes {
    LoadDocument = '[Document] Load',
    LoadDocumentFinished = '[Document] Load Finished',
    LoadDocumentEmpty = '[Document] Empty',
    CancelLoadDocument = '[Documents] Cancel Load Documents',
    LoadLinkAndOpen = '[Documents] Load Link And Open',
    LoadLinkAndOpenFinished = '[Documents] Load Link And Open Finished',
    LoadEsignAndOpen = '[Documents] Load Esgin And Open',
    LoadEsignAndOpenFinished = '[Documents] Load Esign And Open Finished',
    DownloadDocument = '[Document] Download Document',
    OpenOrDownloadDocument = '[Document] Open Or Download Document',
    LoadDocumentError = '[Document] Load document error'
}

export const loadDocument = createAction(DocumentActionTypes.LoadDocument, props<{ contractdetails: GetDocumentParam }>());
export const loadDocumentFinished = createAction(DocumentActionTypes.LoadDocumentFinished, props<{ documentData: DocumentData }>());
export const emptyDocumentData = createAction(DocumentActionTypes.LoadDocumentEmpty);
export const cancelLoadDocuments = createAction(DocumentActionTypes.CancelLoadDocument);
export const loadLinkAndOpen = createAction(DocumentActionTypes.LoadLinkAndOpen);
export const loadLinkAndOpenFinished = createAction(DocumentActionTypes.LoadLinkAndOpenFinished);
export const loadEsignAndOpen = createAction(DocumentActionTypes.LoadEsignAndOpen);
export const loadEsignAndOpenFinished = createAction(DocumentActionTypes.LoadEsignAndOpenFinished);

export const downloadDocument = createAction(DocumentActionTypes.DownloadDocument, props<{ contractdetails: GetDocumentParam; documentType: string }>());

export const openOrDownLoadDocument = createAction(DocumentActionTypes.OpenOrDownloadDocument, props<{ id: string; contractdetails: GetDocumentParam }>());
export const loadDocumentError = createAction(DocumentActionTypes.LoadDocumentError, props<{ documentData: DocumentData; error: string }>());
